module.exports = __webpack_public_path__ + "static/media/18ECA18.7387b397.jpg";